import { ChildModel, ModelBase } from 'store/model-base';
import { SsmStatementSnapshot } from './ssm-statement-snapshot';

export class SsmStatementList extends ModelBase {
    public static storeName: string = 'ssmStatementList';

    public header: string;
    public statements: SsmStatementSnapshot[];

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'statements',
            model: SsmStatementSnapshot
        }];
    }
}
